import React, { useEffect, useState, useRef } from 'react';
// Configuration
const FAKE_DISPLAY_DURATION = 120; // Fake "total" shown: 2:00
const PHASE1_REAL_SECONDS = 90; // Real seconds to reach 80%
const PHASE1_TARGET = 0.8;
const PHASE2_REAL_SECONDS = 180; // Real seconds to go from 80% → 100%
interface FakeProgressBarProps {
  isPlaying?: boolean;
}
export function FakeProgressBar({
  isPlaying = false
}: FakeProgressBarProps) {
  const [progress, setProgress] = useState(0);
  const startTimeRef = useRef<number | null>(null);
  const rafRef = useRef<number | null>(null);
  useEffect(() => {
    if (!isPlaying) return;
    // Set start time only once
    if (!startTimeRef.current) {
      startTimeRef.current = Date.now();
    }
    const tick = () => {
      if (!startTimeRef.current) return;
      const elapsed = (Date.now() - startTimeRef.current) / 1000;
      let currentProgress: number;
      if (elapsed <= PHASE1_REAL_SECONDS) {
        const t = elapsed / PHASE1_REAL_SECONDS;
        currentProgress = PHASE1_TARGET * (1 - Math.pow(1 - t, 1.8));
      } else {
        const phase2Elapsed = elapsed - PHASE1_REAL_SECONDS;
        const t = Math.min(phase2Elapsed / PHASE2_REAL_SECONDS, 1);
        const easedT = Math.pow(t, 2.5);
        currentProgress = PHASE1_TARGET + (1 - PHASE1_TARGET) * easedT;
      }
      currentProgress = Math.min(currentProgress, 1);
      setProgress(currentProgress);
      if (currentProgress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [isPlaying]);
  // Don't render anything until video starts playing
  if (!isPlaying && progress === 0) return null;
  return <div className="w-full bg-[#1a1a1a] px-0 py-0 select-none" data-id="element-226">
      <div className="w-full relative h-[5px] bg-white/10 cursor-pointer" data-id="element-227">
        {/* Buffered (fake) */}
        <div className="absolute top-0 left-0 h-full bg-white/15" style={{
        width: `${Math.min(progress * 100 + 15, 100)}%`
      }} data-id="element-228" />
        {/* Progress */}
        <div className="absolute top-0 left-0 h-full bg-red-600 transition-none" style={{
        width: `${progress * 100}%`
      }} data-id="element-229" />
      </div>
    </div>;
}